/**
 * Utility to format operation types and app names for display
 * Keeps database in snake_case, transforms for UI
 */

export const OPERATION_TYPE_DISPLAY_MAP: Record<string, string> = {
  'text_generation': 'Text Generation',
  'threaded_generation': 'Threaded Generation',
  'research': 'Research',
  'image_generation': 'Image Generation',
  'agent_chat': 'Agent Chat',
  'app_description_generation': 'App Description Generation'
};

export const OPERATION_TYPE_ICONS: Record<string, string> = {
  'text_generation': '📋',
  'threaded_generation': '📄',
  'research': '🔍',
  'image_generation': '🎨',
  'agent_chat': '🤖'
};

export const APP_NAME_ICONS: Record<string, string> = {
  'Task Manager': '📋',
  'Content Generator': '📝',
  'Research': '🔬',
  'Images': '🖼️',
  'AI Agents': '🤖'
};

// Helper function to map app names for consistent display
export const getDisplayAppName = (appName: string): string => {
  switch (appName) {
    case 'Content Generator':
      return 'Workbook';
    case 'Image Generator':
      return 'Images';
    case 'Research Generator':
      return 'Research';
    default:
      return appName;
  }
};

/**
 * Format operation type for display
 */
export function formatOperationType(operationType: string): string {
  return OPERATION_TYPE_DISPLAY_MAP[operationType] || operationType.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
}

/**
 * Get icon for operation type
 */
export function getOperationTypeIcon(operationType: string): string {
  return OPERATION_TYPE_ICONS[operationType] || '⚡';
}

/**
 * Get color scheme for operation type
 */
export function getOperationTypeColor(operationType: string): string {
  const colorMap: Record<string, string> = {
    'text_generation': 'blue',
    'threaded_generation': 'purple', 
    'research': 'green',
    'image_generation': 'orange',
    'agent_chat': 'indigo'
  };
  return colorMap[operationType] || 'gray';
}

/**
 * Get icon for app name
 */
export function getAppNameIcon(appName: string): string {
  return APP_NAME_ICONS[appName] || '📱';
} 